import { useQuery } from '@tanstack/react-query';
import { AgenticInsightsApi } from '@/features/agentic-insights/api/agenticInsightsApi';
import { agenticInsightsQueryKeys } from '@/features/agentic-insights/queryKeys';
import { useAgenticRunDataSource } from './agenticRunDataSource';
import { getLatestRunFixture } from './fixtures';
import { resolveRunPollInterval } from './runLifecycle';
import type { AgenticRun } from './types';

export const useAgenticRun = (loopId: number) => {
  const { dataSource } = useAgenticRunDataSource();

  return useQuery<AgenticRun | null>({
    queryKey: agenticInsightsQueryKeys.latestRun.detail(dataSource, loopId),
    queryFn: () =>
      dataSource === 'mock'
        ? Promise.resolve(getLatestRunFixture(loopId))
        : AgenticInsightsApi.getLatestRun(loopId),
    refetchInterval: (query) => resolveRunPollInterval(query.state.data, Date.now()),
    // dataSource is part of the query key, so toggling Sample data would otherwise drop straight to
    // the loading skeleton for an instant before the new source's data lands. Keeping the previous
    // source's data on screen until the new fetch resolves avoids that flash.
    placeholderData: (previousData) => previousData,
  });
};
